@switch (type()) {
  @case (typeEnum.HOLIDAYS) {
    <div class="absence-type type-holidays-color" i18n>Vacaciones</div>
  }
  @case (typeEnum.SICKNESS) {
    <div class="absence-type type-sickness-color" i18n>Enfermedad</div>
  }
  @case (typeEnum.OTHER) {
    <div class="absence-type type-other-color" i18n>Otro</div>
  }
  @default {}
}
